import List from "@mui/material/List";
import Box from "@mui/material/Box";
import NoRecordFound from "src/components/shared/molecules/NoRecordFound";
import Response from "./response";
import useStyles from "./Styles";

interface ListDataProp {
  id: number;
  short: string;
  long: string;
}

interface Props {
  data: any;
  loading: boolean;
  handleDeleteResponse: (id: number) => void;
  setRemoveModal: any;
}

const ListItems: React.FC<Props> = ({
  data,
  handleDeleteResponse,
  loading,
  setRemoveModal,
}) => {
  const { classes } = useStyles();
  return (
    <List
      className={classes.listItemContainer}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      {data.length > 0 ? (
        data.map((curr: ListDataProp) => {
          return (
            <Response
              response={curr}
              loading={loading}
              handleDeleteResponse={handleDeleteResponse}
              setRemoveModal={setRemoveModal}
            />
          );
        })
      ) : (
        <Box mt={3}>
          <NoRecordFound />
        </Box>
      )}
    </List>
  );
};

export default ListItems;
